var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{class:_vm.badgeClass},[_c('font-awesome-icon',{attrs:{"icon":_vm.icon}}),_vm._v("\n  "+_vm._s(_vm.appointmentNumber.replace(/^0+/, ""))+"\n")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }